import { TableDto } from '@/core';
import { TableTypesEnum } from './useTypeOptions';

export const useFilteredTablesByType = (tables: TableDto[], filterValue: TableTypesEnum) => {
  const filteredTables =
    filterValue === TableTypesEnum.All ? tables : tables.filter((table) => table.type === filterValue);

  const getItemsQuantityByFilter = (filterValue: string) =>
    tables.filter((table) => table.type === filterValue).length;

  return { filteredTables, getItemsQuantityByFilter };
};
